<template>
  <div class="contact-section">
    <div class="contact-image">
      <MediaSlotImage
        slot-code="work.contact"
        :fallback="image"
        alt="Eyewear lifestyle"
        sizes="(max-width: 767px) 100vw, 50vw"
        :width="960"
        :height="1200"
      />
    </div>
    <div class="contact-content">
      <span class="contact-eyebrow">Get In Touch</span>
      <h2 class="contact-title">Let's<br />Make Something<br />Great</h2>
      <p class="contact-body">
        Ready to collaborate? Send us a message and tell us about yourself —
        your platform, your style, and why you love eyewear.
      </p>
      <div class="contact-email-block">
        <span class="contact-email-label">Contact us at</span>
        <a class="contact-email-link" :href="'mailto:' + email">{{ email }}</a>
      </div>
      <a class="btn-primary" :href="'mailto:' + email">Send a Message</a>
    </div>
  </div>
</template>

<script>
import { cdnUrl } from "~/utils/cdn";
import MediaSlotImage from "~/core/components/atoms/media-slot-image/media-slot-image.vue";

export default {
  name: "WorkWithUsContact",
  components: { MediaSlotImage },
  props: {
    email: {
      type: String,
      default: "admin@hooliganseyewear.com",
    },
    image: {
      type: String,
      default: () =>
        cdnUrl("/image/HOOLIGANS+WEB/Work+With+Us/Untitled+design+(2).jpg"),
    },
  },
};
</script>
